<template lang="pug">
div
  maintenance-screen(v-if="$root.isMaintenanceMode && !$root.maintenanceStaffLogin")
  template(v-else)
    //- Reminder for staff/test accounts using the app while maintenance is on
    div(v-if="$root.maintenanceBypass" style="position:sticky;top:0;z-index:1060;background:#b45309;color:#fff;font-size:0.8rem;font-weight:700;text-align:center;padding:0.3rem 0.5rem;")
      | Maintenance bypass
    b-alert.fixed-top(v-model="$root.installReady" variant="dark" fade)
      .d-flex.align-items-center.justify-content-between
        b-img.mr-3(src="img/icons/android-chrome-maskable-512x512.png" style="max-height:80px;" thumbnail)
        div.font-weight-bold
          p.mb-1 For the best experience, install the app on your phone.
          p.small.mb-0
            a(href="#" @click="$root.installClicked=true") Continue in mobile website instead
        b-button.d-flex.align-items-center.justify-content-center.ml-2.align-self-stretch.flex-wrap(@click="$root.installApp" variant="warning"  size="sm")
          //b-icon-download
          span.font-weight-bold Get App
    b-modal(v-model="$root.noInstallprompt" title="Install DSG FOW App" hide-footer)
      .d-flex.align-items-center
        b-img.mr-3(src="img/icons/android-chrome-maskable-512x512.png" style="max-height:80px;" thumbnail)
        h6 For the best experience, install the app on your phone.
      hr
      p.lead Instructions for iPhone users:
      ol
        li.mb-1 Click on <b-button variant="outline-secondary" size="sm" style="vertical-align: middle;" class="m-0  py-1"><icon icon="material-symbols:ios-share-rounded"/></b-button> at the bottom
        li.mb-1 Scroll down and click on<br/><b-button variant="outline-secondary" size="sm" style="vertical-align: middle;" class="m-0 py-1">Add to Home Screen <icon icon="material-symbols:add-box-outline"/></b-button>
        li.mb-1 Confirm and press add
        //b-accordion-item(title="Instructions for Firefox(Android)")
          ol
            li Click on <b-button variant="outline-secondary" size="sm" style="vertical-align: middle;" class="m-0  py-1"><Icon icon="material-symbols:more-vert"/></b-button> at the top right
            li Scroll down and click on <br/><b-button variant="outline-secondary" size="sm" style="vertical-align: middle;" class="m-0 py-1"><firefox-icon alt="installicon" style="height:15px; width:auto;" class="me-2"/>Install</b-button>
            li Confirm and press add
      hr
      b-button(block style="width:100%;" variant="success" @click="$root.noInstallprompt=false") Nevermind, let me use the mobile website instead
    b-overlay(:show="$root.changingClient")
      nav-bar(v-if="!hideHeaderPages.includes($route.path)")
      //- header-side(v-if="!hideHeaderPages.includes($route.path)")
      transition(name="fade" mode="out-in")
        router-view
</template>

<script>
import HeaderSide from '@/components/HeaderSide.vue'
import { Icon } from '@iconify/vue2';
import NavBar from './components/NavbarV2.vue';
import MaintenanceScreen from './components/MaintenanceScreen.vue';

export default {
  data() {
    return {
      hideHeaderPages: ['/welcome', '/login']
    }
  },
  components: {
    HeaderSide,
    Icon,
    NavBar,
    MaintenanceScreen
  },
  computed: {
    users() {
      return this.$store.state.users;
    },
    caregiver(){
      return this.$store.state.caregiver;
    },
    pastsessions() {
      return this.$store.state.pastsessions;
    },
    announcements() {
      return this.$store.state.announcements;
    },
    reminders() {
      return this.$store.state.reminders;
    },
    invoice_lists() {
      return this.$store.state.invoice_lists;
    },
    invoices() {
      return this.$store.state.invoices;
    },
  },
  provide() {
    return {
      users: this.users,
      pastsessions: this.pastsessions,
      announcements: this.announcements,
      reminders: this.reminders,
      // invoice_lists: this.invoice_lists,
      // invoices: this.invoices,
    };
  },
  async mounted() {},
};
</script>

<style>
/* Swap tap-to-confirm dialog (rendered at body level, so not scoped) */
.swap-confirm-line { text-align: center; padding: 0.35rem 0; }
.swap-confirm-label { font-size: 0.7rem; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase; color: #8a8a96; }
.swap-confirm-date { font-size: 1.05rem; font-weight: 800; color: #222; }
.swap-confirm-sched { font-size: 0.85rem; color: #555; }
.swap-confirm-arrow { text-align: center; color: #8967b3; font-size: 1.4rem; line-height: 1; }
.swap-confirm-footer .btn { flex: 1; font-weight: 700; }
</style>
<style lang="scss">
.clickable {
  cursor: pointer;
}

$base-color-purple: #50276b;
$base-color-yellow: #ffcd06;
* {
  box-sizing: border-box;
}
html {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
body {
  margin: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>
